'use strict';

import angular from 'angular';

/**
 * Service de gestion des favoris
 */
export default angular.module('observatoireApp')
  .factory('FavorisService', ['$http', 'StorageService', function($http, StorageService) {
      
      var FAVORIS_KEY_PREFIX = 'userFavoris_';

      function getKey() {
        try {
          var userJson = StorageService.get('currentUser');
          if (userJson) {
            var user = angular.fromJson(userJson);
            if (user && user.id) {
              return FAVORIS_KEY_PREFIX + user.id;
            }
          }
        } catch (e) {}
        return FAVORIS_KEY_PREFIX + 'anonymous';
      }

      var service = {
        getFavoris: getFavoris,
        addFavori: addFavori,
        removeFavori: removeFavori,
        isFavori: isFavori,
        clearFavoris: clearFavoris,
        migrerAnciensFavoris: migrerAnciensFavoris
      };
      
      // Migrer les anciens favoris vers la nouvelle structure
      migrerAnciensFavoris();
      
      return service;
      
      /**
       * Récupère tous les favoris de l'utilisateur connecté
       * @returns {Array} Liste des favoris
       */
      function getFavoris() {
        var favorisJson = StorageService.get(getKey());
        if (favorisJson) {
          return angular.fromJson(favorisJson);
        }
        return [];
      }
      
      /**
       * Fonction pour migrer les anciens favoris vers la nouvelle structure hiérarchique
       */
      function migrerAnciensFavoris() {
        var favoris = getFavoris();
        var estModifie = false;
        
        favoris.forEach(function(favori) {
          // Vérifier si le favori est dans l'ancien format (sans jeuDonnees et typeDonnees)
          if (!favori.jeuDonnees && !favori.typeDonnees) {
            estModifie = true;
            
            // Déterminer le jeu de données et le type en fonction de l'ancien champ type
            if (favori.type === 'recettes-dons' || favori.type === 'depenses' || favori.type === 'financement') {
              // C'est un type du TOFE
              favori.jeuDonnees = 'tableau-des-operations-financieres-de-letat';
              favori.jeuDonneesLibelle = 'Tableau des opérations financières de l\'\u00c9tat';
              favori.typeDonnees = favori.type;
              
              // Mettre à jour le libellé du type
              if (favori.type === 'recettes-dons') {
                favori.typeDonneesLibelle = 'Recettes et dons';
              } else if (favori.type === 'depenses') {
                favori.typeDonneesLibelle = 'Dépenses';
              } else if (favori.type === 'financement') {
                favori.typeDonneesLibelle = 'Financement';
              }
            } else {
              // Par défaut, on suppose que c'est le budget de l'Etat
              favori.jeuDonnees = 'budget-etat';
              favori.jeuDonneesLibelle = 'Budget de l\'\u00c9tat';
              favori.typeDonnees = favori.type;
              favori.typeDonneesLibelle = favori.libelle || 'Type non spécifié';
            }
          }
        });
        
        // Si des modifications ont été apportées, enregistrer les favoris
        if (estModifie) {
          StorageService.set(getKey(), angular.toJson(favoris));
        }
      }
      
      /**
       * Ajoute un jeu de données aux favoris
       * @param {Object} dataset - Jeu de données à ajouter aux favoris
       * @returns {Boolean} - Vrai si l'ajout a réussi
       */
      function addFavori(dataset) {
        var favoris = getFavoris();
        
        // Vérifier que le favori n'existe pas déjà
        var exists = favoris.some(function(item) {
          return item.id === dataset.id;
        });
        
        if (!exists) {
          favoris.push({
            id: dataset.id,
            // Type générique (publication, texte-officiel, dataset)
            itemType: dataset.itemType || 'dataset',
            titre: dataset.titre || null,
            categorie: dataset.categorie || null,
            fileUrl: dataset.fileUrl || null,
            fileType: dataset.fileType || null,
            // Conserver type et libelle pour compatibilité descendante
            type: dataset.typeDonnees || dataset.type,
            libelle: dataset.typeDonneesLibelle || dataset.libelle,
            // Structure hiérarchique dataset
            jeuDonnees: dataset.jeuDonnees,
            jeuDonneesLibelle: dataset.jeuDonneesLibelle,
            typeDonnees: dataset.typeDonnees,
            typeDonneesLibelle: dataset.typeDonneesLibelle,
            annee: dataset.annee,
            dateAjout: new Date()
          });
          
          StorageService.set(getKey(), angular.toJson(favoris));
          return true;
        }
        
        return false;
      }
      
      /**
       * Supprime un jeu de données des favoris
       * @param {String} datasetId - ID du jeu de données à supprimer
       * @returns {Boolean} - Vrai si la suppression a réussi
       */
      function removeFavori(datasetId) {
        var favoris = getFavoris();
        var initialLength = favoris.length;
        
        favoris = favoris.filter(function(item) {
          return item.id !== datasetId;
        });
        
        if (favoris.length !== initialLength) {
          StorageService.set(getKey(), angular.toJson(favoris));
          return true;
        }
        
        return false;
      }
      
      /**
       * Vérifie si un jeu de données est dans les favoris
       * @param {String} datasetId - ID du jeu de données à vérifier
       * @returns {Boolean} - Vrai si le jeu de données est un favori
       */
      function isFavori(datasetId) {
        var favoris = getFavoris();
        return favoris.some(function(item) {
          return item.id === datasetId;
        });
      }
      
      /**
       * Efface tous les favoris de l'utilisateur
       */
      function clearFavoris() {
        StorageService.remove(FAVORIS_KEY);
      }
    }]);

